export default {
  setUser: (state, { name, role, organizationId, organizationName, organizationAbbreviation }) => {
    state.name = name;
    state.role = role;
    state.organizationId = organizationId;
    state.organizationName = organizationName;
    state.organizationAbbreviation = organizationAbbreviation;
  },

  setUserInfo: (state, userInfo) => {
    state.userInfo = userInfo;
  }
};
